

import React, { useRef } from "react";
import Table from "react-bootstrap/Table";
import { Bar } from "react-chartjs-2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Import images for PDF header and footer

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";

const AeroTable13 = ({ data }) => {
  const pdfRef = useRef(); // Reference for PDF capture

  const chartData = {
    labels: data.map((item) => item.age_group_label),
    datasets: [
      {
        label: "Female Employment (2024)",
        data: data.map((item) => parseInt(item.female_2024, 10)),
        backgroundColor: "rgba(1, 76, 178)",
        borderColor: "rgba(1, 76, 178, 1)",
        borderWidth: 1,
      },
      {
        label: "Male Employment (2024)",
        data: data.map((item) => parseInt(item.male_2024, 10)),
        backgroundColor: "rgba(203, 12, 12)",
        borderColor: "rgba(203, 12, 12, 1)",
        borderWidth: 1,
      },
      {
        label: "Female Percentage (%)",
        data: data.map((item) => parseFloat(item.percentage)),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        type: "line",
        borderWidth: 2,
        tension: 0.3,
        yAxisID: "y1",
      },
    ],
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    input.style.width = "1100px"; // Expand width for better PDF capture

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Header
      pdf.addImage(utahData, "PNG", 60, 10, 32, 16);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);
      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });
      pdf.setFontSize(12);
      pdf.line(10, 35, 200, 35);

      // Main Content
      pdf.addImage(imgData, "PNG", 5, 38, imgWidth, imgHeight);

      // Footer
      pdf.line(10, 260, 200, 260);
      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 22, 265, 30, 15);
      pdf.setFontSize(10);
      pdf.text("Built by", 55, footerStartY + 10);
      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);
      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);
      const currentDate = new Date().toLocaleDateString();
      pdf.text(`Downloaded on: ${currentDate}`, 150, 295);
      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("employment-2024.pdf");
      input.style.width = ""; // Reset width
    });
  };

  return (
    <div className="container">
      <div ref={pdfRef} className="content-to-export">
        {/* Table Section */}
        <div className="table-responsive">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Age Group</th>
                <th>Female Employment (2024)</th>
                <th>Male Employment (2024)</th>
                <th>Female Percentage (%)</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>{item.age_group_label}</td>
                  <td>{item.female_2024}</td>
                  <td>{item.male_2024}</td>
                  <td>{item.percentage}%</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

     

        <div
          style={{
            width: "90%",
            maxWidth: "800px",
            margin: "auto",
            overflowX: "auto",
          }}
        >
          {" "}
          <div
            style={{
              width: "100%", // Takes 100% width of the parent div, but will scroll if needed
              minWidth: "600px", // Ensures a minimum width, enabling scroll when the chart exceeds screen size
              height: "400px",
              background: "#fff",
            }}
          >
            <Bar
              data={chartData}
              options={{ responsive: true, maintainAspectRatio: false }}
            />
          </div>
        </div>
      </div>

      {/* Download PDF Button */}
      <div className="flex justify-center mt-4">
        <div className="flex justify-center mt-4">
          <button
            onClick={downloadPDF}
            className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
          >
            <span>Download as PDF</span>
            <span>
              <img className="w-[2rem]" src={pdf} alt="PDF Icon" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AeroTable13;
